<template> 
  <div> 
    <b-container fluid>
      <b-row>
        <b-col>  
        <!--   <Cotizaciones v-if="esAdministrador()"/> -->
           <Cotizaciones v-if="esSupervisor() || esAdministrador()"/>   
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <MisCotizaciones v-if="esVendedor() || esSupervisor() || esAdministrador()"/>  
        </b-col>
      </b-row>
     <!--  <b-row>
        <b-col>
          <Usuarios  v-if="!esVendedor()"/>
        </b-col>
        <b-col v-if="esSupervisor() || esAdministrador()">
          <Empleados />
        </b-col>
      </b-row> -->
    </b-container>
  </div>
</template>

<script>
// @ is an alias to /src
import Usuarios from '@/components/Empleados/Usuarios.vue'
import Cotizaciones from '@/components/Cotizaciones/Cotizaciones.vue' 
import MisCotizaciones from '@/components/Cotizaciones/MisCotizaciones.vue'
import Empleados from '@/components/Empleados/Empleados.vue'

export default {
  name: 'home',
  components: {
    Usuarios,
    Cotizaciones, 
    MisCotizaciones,
    Empleados
  }
}
</script>
